export default __webpack_public_path__ + "media/images/icons/safari-811e0ddd009a03b0beb0b12447a86aaa.png";